import * as React from "react";
import type { SVGProps } from "react";
const SvgSwiss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path fill="#cf0a2c" d="M40.182 43H1L29.706 7H49z" />
    <path
      fill="#fff"
      d="M34.178 21.683v-7.766H27.58v7.766h-7.724v6.634h7.692v7.735h6.63v-7.735h7.692v-6.634z"
    />
  </svg>
);
export default SvgSwiss;
